import { IFocusBehavior, IFocusBehaviorSpecifiable } from "../../../../../../../documaker/domain/format/objects";
import { IObjectBeanFixedTextDrawable } from "../../../beans/objects";

export class FocusBehaviorTranslator {
  from(bean: IObjectBeanFixedTextDrawable): IFocusBehavior {
    return {
      isEnable: (bean["@focus"] !== "0"),
    };
  }

  to(o: IFocusBehaviorSpecifiable) {
    return {
      focus: o.focusBehavior.isEnable
        ? undefined
        : "0",
    };
  }
}
